import { PERMISSIONS } from "@/constants/permissions";

/**
 * Permission checks for the Feature videos section (MISC_FV1-3). Off for now: every logged-in user sees and uses
 * everything. Set to true together with FV_ENFORCE_PERMISSIONS in misc-svc (feature-video.constants.ts).
 */
export const FV_ENFORCE_PERMISSIONS = false;

/** Route/sidebar permissions: none while the check is off. */
export const FV_ROUTE_PERMISSIONS: string[] = FV_ENFORCE_PERMISSIONS ? [PERMISSIONS.MISC_FEATURE_VIDEOS_LIST] : [];

/** Has the user this feature-video permission? Always true while the check is off. */
export const fvCan = (codes: string[] | undefined, code: string) => !FV_ENFORCE_PERMISSIONS || (codes || []).includes(code);
